import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarComposeFormStore"*/ './lazyIndex')
);

// InitActions - async since they can be used in non-compose packages
export const lazyShowFullCompose = new LazyAction(lazyModule, m => m.showFullCompose);
export const lazyShowFullComposeFromPriorState = new LazyAction(
    lazyModule,
    m => m.showFullComposeFromPriorState
);
export const lazyShowFullComposeToEdit = new LazyAction(lazyModule, m => m.showFullComposeToEdit);

export const lazyShowQuickCompose = new LazyAction(lazyModule, m => m.showQuickCompose);

export const lazySetCollabSpaceViewStateId = new LazyAction(
    lazyModule,
    m => m.setCollabSpaceViewStateId
);

// Selectors
export const lazyIsQuickComposeOpen = new LazyImport(lazyModule, m => m.isQuickComposeOpen);
export const lazyIsFullComposeOpen = new LazyImport(lazyModule, m => m.isFullComposeOpen);

// NOTE: These non-lazy actions are for subscription purposes only
//       Do not invoke outside of compose form orchestration
export { notifyOnCalendarIdChanged } from './actions/notifyOnCalendarIdChanged';
export { onShowFullCompose } from './actions/formOpenCloseNotificationActions';
export { onCloseFullCompose } from './actions/formOpenCloseNotificationActions';
export { onShowQuickCompose } from './actions/formOpenCloseNotificationActions';
export { onCloseQuickCompose } from './actions/formOpenCloseNotificationActions';
